"use client";

import React from "react";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card";
import { ClipboardList, Activity, Cpu, Zap, Truck } from "lucide-react";
const processSteps = [{
  id: 1,
  title: "Intake",
  description: "Secure logging of equipment, initial visual inspection, and comprehensive documentation of customer concerns for Miller, Lincoln, or Hypertherm units.",
  icon: ClipboardList
}, {
  id: 2,
  title: "Precision Diagnostic",
  description: "State-of-the-art testing using advanced oscilloscopes and diagnostic tools to pinpoint component-level failures and circuit board issues.",
  icon: Activity
}, {
  id: 3,
  title: "Component Repair",
  description: "Expert micro-soldering, specialized circuit board repair, and precise replacement of faulty parts adhering strictly to OEM specifications.",
  icon: Cpu
}, {
  id: 4,
  title: "Load Testing",
  description: "Rigorous stress testing under maximum operational loads to ensure sustained performance, arc stability, and long-term reliability.",
  icon: Zap
}, {
  id: 5,
  title: "Delivery",
  description: "Final calibration checks, generation of detailed repair reporting, and secure return of your fully restored welding or plasma equipment.",
  icon: Truck
}];
export default function OurTechnicalProcess() {
  return <section id="our-technical-process" className="relative py-24 bg-background overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.03] dark:opacity-[0.05]" style={{
      backgroundImage: `linear-gradient(to right, var(--color-primary) 1px, transparent 1px), linear-gradient(to bottom, var(--color-primary) 1px, transparent 1px)`,
      backgroundSize: '2rem 2rem'
    }} />

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16 md:mb-24">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4 tracking-tight">
            Our Technical Process
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg">
            A systematic, high-tech approach to minimizing downtime and restoring your heavy-duty equipment to peak operational efficiency.
          </p>
        </div>

        <div className="relative max-w-6xl mx-auto">
          {}
          <div className="absolute left-[27px] md:left-0 top-0 md:top-7 h-full md:h-1.5 w-1.5 md:w-full bg-muted-foreground/20 -translate-x-1/2 md:translate-x-0 rounded-full" />

          <div className="flex flex-col md:flex-row justify-between items-start md:items-start gap-12 md:gap-4">
            {processSteps.map((step, i) => {
            const Icon = step.icon;
            return <div key={step.id} data-index={i} className="relative flex flex-row md:flex-col items-start md:items-center gap-6 md:gap-4 w-full md:w-48 group">
                  <HoverCard openDelay={100} closeDelay={100}>
                    <HoverCardTrigger asChild>
                      <button className="relative z-10 flex items-center justify-center size-14 rounded-full bg-primary text-primary-foreground font-bold text-xl shadow-lg shadow-primary/20 transition-all duration-300 group-hover:scale-110 group-hover:shadow-primary/40 cursor-help shrink-0 border-4 border-background outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background">
                        {step.id}
                      </button>
                    </HoverCardTrigger>
                    <HoverCardContent side="top" align="center" sideOffset={16} className="w-80 p-5 shadow-xl border-primary/20 bg-card/95 backdrop-blur-sm">
                      <div className="flex items-center gap-3 mb-3">
                        <div className="p-2 bg-primary/10 rounded-md text-primary">
                          <Icon className="size-5" />
                        </div>
                        <h4 className="font-bold text-lg text-foreground leading-none">
                          {step.title}
                        </h4>
                      </div>
                      <p className="text-sm text-muted-foreground leading-relaxed">
                        {step.description}
                      </p>
                    </HoverCardContent>
                  </HoverCard>

                  {}
                  <div className="text-left md:text-center pt-3 md:pt-0">
                    <h3 className="font-semibold text-foreground text-lg md:text-base leading-tight">
                      {step.title}
                    </h3>
                    {}
                    <p className="text-sm text-muted-foreground mt-2 md:hidden leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}